export enum EDetectionsPerm {
    DETECTIONS_VIEW = 'detections_view',
    DETECTIONS_EDIT = 'detections_edit',
    DETECTIONS_DELETE = 'detections_delete'
}
